export enum ComplaintResolutionAction {
  Refund = 'refund',
  RequestToReturn = 'request_to_return',
  ChooseResolution = 'choose_resolution',
  CancelRefundOffer = 'cancel_refund_offer',
}

export enum ComplaintResolutionChoice {
  Refund = 'refund',
  RequestToReturn = 'request_to_return',
  OfferPartialRefund = 'offer_partial_refund',
}

export enum ComplaintOrderType {
  C2C = 'c2c',
  B2C = 'b2c',
  B2B = 'b2b',
  C2B = 'c2b',
}

export enum EstimatedRefundFactualShippingMethod {
  Custom = 'custom',
  Integrated = 'integrated',
}

export enum EstimatedRefundInformationModal {
  EstimatedRefund = 'estimatedRefund',
  BuyerProtectionFee = 'buyerProtectionFee',
  CurrencyConversion = 'currencyConversion',
  ItemDiscounts = 'itemDiscounts',
}

export enum RefundOfferAction {
  Accept = 'accept',
  Reject = 'reject',
  Cancel = 'cancel',
}
